module.exports = __webpack_public_path__ + "media/application/images/svgs/rotate-cw-0bae83b5d113116c403c76dfb2904617.svg";